const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const isValidFloat = (value) => {
  const regex = /^\d+(\.\d+)?$/;
  return regex.test(value);
};

export const handleOnDragEnd = (
  result,
  list = [],
  setList = () => {},
  callback = () => {}
) => {
  const items = reorder(list, result.source.index, result.destination.index);
  setList(items);
  callback(items);
};

export const initialsValue = (str = "") => {
  const strArr = str?.split(" ");
  const initials =
    (strArr &&
      Array.isArray(strArr) &&
      strArr[0]
        .slice(0, 1)
        .concat(strArr?.length > 1 ? strArr.at(-1).slice(0, 1) : "")
        .toUpperCase()) ||
    [];
  return initials;
};


export const getMetaData = (res) => {
  return {
    hasNextPage: res?.hasNextPage,
    hasPrevPage: res?.hasPrevPage,
    limit: res?.limit,
    nextPage: res?.nextPage,
    offset: res?.offset,
    page: res?.page,
    pagingCounter: res?.pagingCounter,
    prevPage: res?.prevPage,
    totalDocs: res?.totalDocs,
    totalPages: res?.totalPages,
  };
};

export function getOffset(selectedPage, limit) {
  return (selectedPage ?? 0) * (limit ?? 10) - (limit ?? 10);
}

export const errorMessageCheck = (errors, name, type = "required") => {
  const error_obj = {};
  if (errors && errors[name] && name && Object.keys(errors[name])?.length > 0) {
    error_obj[`errorType`] =
      type === "required"
        ? "warning"
        : type === "info"
        ? "info"
        : type === "success"
        ? "success"
        : "error";
    error_obj[`errorText`] = errors[name];
  }

  return error_obj;
};

export const elementResize = (ref = {}, setMesurement = () => {}) => {
  const handleResize = () => {
    if (ref.current) {
      const divWidth = ref.current.clientWidth;
      const divHeight = ref.current.offsetHeight;
      setMesurement({
        width: divWidth,
        height: divHeight,
      });
      // You can now use the divWidth as needed, e.g., update state or perform other actions.
    } else {
      const divWidth = document.body.clientWidth;
      const divHeight = document.body.offsetHeight;
      setMesurement({
        width: divWidth,
        height: divHeight,
      });
    }
  };

  // Initial call to get the width when the component mounts
  handleResize();

  const resizeObserver = new ResizeObserver(handleResize);

  if (ref.current) {
    resizeObserver.observe(ref.current);
  } else {
    resizeObserver.observe(document.body);
  }

  return () => {
    resizeObserver.disconnect();
  };
};